import styled from 'styled-components'
import Popup from 'reactjs-popup'
import colors from '@settings/styleSettings'
import Card from '@components/card'

export const NameAligner = styled.div`
  margin-left: 15px;
`
export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`
export const Text = styled.div`
  font-family: Circular-Std;
  text-align: left;
`
export const TextPopUp = styled.div`
  font-family: Circular-Std;
  text-align: center;
  color: ${colors.background};
  font-size: 12px;
  `
export const InfoBoxContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`
export const ToolTipCard = styled(Card)`
  box-shadow: 1px 2px 6px -2px ${colors.strongGray};
  display: flex-column;
  margin: 0;
  padding: 12px;
  flex-direction: column;
`

export const Buttons = styled.div`
  display: flex;
  gap: 12px;
  margin-right: 24px;
  width: 100%;
`
export const BarChartIcon = styled.div`
  width: 24px;
  height: 24px;
  color: ${colors.background};
`

export const CheckCircleOutlineIcon = styled.div`
  width: 24px;
  height: 24px;
  color: ${colors.background};
`

export const MoreHorizIcon = styled.div`
  width: 24px;
  height: 24px;
  color: ${colors.strongGray};
`

export const StyledPopup = styled(Popup)`
  &-content {
    background: ${colors.titleStrongBlack};
    margin: auto;
    padding: 8px 12px 8px 12px;
    border-radius: 10px;
    background-color: #39C98F;
    color: #fff;
    font-weight: 600;
  }
  &-arrow {
    color: #39C98F;
  }
`

export const ActionsGrid = styled.div`
  display: inline-grid;
  grid-template-columns: repeat(3, 40px);
  grid-template-rows: 40px;
  grid-template-areas: "report consent camera";
  gap: 8px;

  justify-items: center;
  align-items: center;

  /* Garante que o grid ocupa o espaço necessário */
  width: 100%;
  min-width: 100px;

  /* Alinha a grade para a direita da célula */
  justify-content: center;
  align-content: center;

  .reactjs-popup-trigger, & > .btn {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }

  .btn-report  { grid-area: report; }
  .btn-consent { grid-area: consent; }
  .btn-camera  { grid-area: camera; }
`

export const ActionsCell = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;   /* antes: flex-end */
  align-items: center;
  padding-left: 0;
  padding-right: 10px;          /* não precisa “empurrar” */
  box-sizing: border-box;
`
